// 'https://rajapinnat.ymparisto.fi/api/Hakemistorajapinta/1.0/odata/Maakunta'
// manually edited to array
export const regions = [
    { value: 1, label: 'Uusimaa' },
    { value: 2, label: 'Varsinais-Suomi' },
    { value: 4, label: 'Satakunta' },
    { value: 5, label: 'Kanta-Häme' },
    { value: 6, label: 'Pirkanmaa' },
    { value: 7, label: 'Päijät-Häme' },
    { value: 8, label: 'Kymenlaakso' },
    { value: 9, label: 'Etelä-Karjala' },
    { value: 10, label: 'Etelä-Savo' },
    { value: 11, label: 'Pohjois-Savo' },
    { value: 12, label: 'Pohjois-Karjala' },
    { value: 13, label: 'Keski-Suomi' },
    { value: 14, label: 'Etelä-Pohjanmaa' },
    { value: 15, label: 'Pohjanmaa' },
    { value: 16, label: 'Keski-Pohjanmaa' },
    { value: 17, label: 'Pohjois-Pohjanmaa' },
    { value: 18, label: 'Kainuu' },
    { value: 19, label: 'Lappi' },
    { value: 21, label: 'Ahvenanmaa' }
];


// WEBPACK FOOTER //
// ./resources/assets/js/constants/regions.js